module.exports = __webpack_public_path__ + "img/screenshot3-b.8258e69a.jpg";